import { postRequest } from "../../../services/RestServices";
import * as urls from "../../api/C4S Decommission - Replacement/url";

export const validateVin = async (data) => {
  try {
    return await postRequest(urls.VALIDATE_VIN, data);
  } catch (err) {
    return err;
  }
};

export const saveVin = async (data) => {
  try {
    return await postRequest(urls.SAVE_VINS, data);
  } catch (err) {
    return err.response;
  }
};
